import axios from 'axios';

const state = {
  userActivities: [],
  pagination: {
    page: 1,
    perPage: 10,
    totalItems: 0,
    previousPageLink: null,
    nextPageLink: null
  }
};

const actions = {
  async fetchUserActivities({ commit, dispatch }, params) {
    dispatch('loading/showLoading', null, { root: true });
    
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${process.env.VUE_APP_ROOT_API}/user-activities`, {
        headers: {
          'Authorization': `Bearer ${token}`
        },
        params: params
      });

      const data = response.data;
      commit('setUserActivities', data);
      commit('setPagination', data.pagination);
    }
    catch (error) {
      console.error('Failed to fetch user activities: ', error);
    }
    finally {
      dispatch('loading/hideLoading', null, { root: true });
    }
  },
};

const mutations = {
  setUserActivities(state, userActivities) {
    state.userActivities = userActivities.data || [];
  },
  
  setPagination(state, pagination) {
    state.pagination.page = pagination.page || 1;
    state.pagination.perPage = pagination.perPage || 10;
    state.pagination.totalItems = pagination.totalItems || 0;

    state.pagination.previousPageLink = pagination.previousPageLink
      ? pagination.previousPageLink.replace(/\/api\/v1\/user-activities\?/, '')
      : null;
    state.pagination.nextPageLink = pagination.nextPageLink
      ? pagination.nextPageLink.replace(/\/api\/v1\/user-activities\?/, '')
      : null;
  },
};

const getters = {
  allUserActivities: (state) => state.userActivities,
  pagination: (state) => state.pagination,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
